import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import isEmpty from 'lodash/isEmpty';
import * as locationActions from 'shared/ducks/locationDuck';
import { Card, AlertNotice } from 'shared/components';
import { LOCATION_STATUS } from 'shared/constants';

import './TcLocations.scss';

class TcLocations extends Component {
  constructor(props) {
    super(props);

    this.state = {
      locations: props.tcCycle.locations,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.tcCycle.locations !== this.props.tcCycle.locations) {
      this.setState({
        locations: this.props.tcCycle.locations,
      });
    }
  }

  render() {
    const { locations } = this.state;
    if (isEmpty(this.props.tcCycle)) {
      return null;
    }

    if (!locations || !locations.length) {
      return (
        <section className="tc-locations-section tc-no-locations">
          <h5 className="mb-4">{this.props.t('testCenter.testingLocationsTitle', { total: 0 })}</h5>
          <AlertNotice message={this.props.t('testCenter.noLocationsLabel')} />
        </section>
      );
    }

    return (
      <section className="tc-locations-section">
        <h5 className="mb-4">
          {this.props.t('testCenter.testingLocationsTitle', {
            total: locations.length,
          })}
        </h5>
        <div className="card-container">
          {locations.map((location) => (
            <Card small key={location.id}>
              <div className="position-relative h-100">
                <div className="location-name fw-bold text-ellipsis-3-lines">
                  {`${location.name}${location.area.length > 0 ? `, ${location.area}` : ''}`}
                </div>
                {location.locationStatus.status === LOCATION_STATUS.closed && (
                  <span className="location-label location-closed">
                    {this.props.t('common.labels.closed')}
                    <i className="fa fa-exclamation-triangle ps-1"></i>
                  </span>
                )}
              </div>
            </Card>
          ))}
        </div>
      </section>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators({ ...locationActions }, dispatch) };
}

export default withTranslation()(connect(null, mapDispatchToProps)(TcLocations));

TcLocations.propTypes = {
  tcCycle: PropTypes.shape({
    locations: PropTypes.arrayOf(PropTypes.shape({})),
    id: PropTypes.number,
  }).isRequired,
  actions: PropTypes.shape({
    updateLocations: PropTypes.func,
    setInstitutionAction: PropTypes.func,
  }).isRequired,
  t: PropTypes.func.isRequired,
};
